// import { useState, useEffect, useRef } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import { useAuth } from "../hooks/useAuth";
// import { getScratchResumeEligibility, markScratchResumeGenerated, saveGeneratedResume } from "../utils/transactions";
// import { downloadATSResume, downloadResumeAsWord, downloadResumeAsPDF, buildResumeHTML } from "../utils/generateResumeDoc";
// import servicesConfig from "../utils/servicesConfig";
// import apiConfig from "../utils/apiConfig";
// import TemplateMini from "../components/TemplateMini";

// // ── Domain options ──
// // eslint-disable-next-line no-unused-vars
// const DOMAINS = [
//   { value: "Technology / Software",     icon: "💻", desc: "Software, engineering, data, DevOps" },
//   { value: "Healthcare / Medical",       icon: "🏥", desc: "Nursing, clinical, pharmacy, allied health" },
//   { value: "Finance / Banking",          icon: "📈", desc: "Accounting, investment, insurance, banking" },
//   { value: "Marketing / Sales",          icon: "📣", desc: "Digital marketing, sales, PR, brand" },
//   { value: "Operations / Logistics",     icon: "⚙️",  desc: "Supply chain, manufacturing, project mgmt" },
//   { value: "Legal",                      icon: "⚖️",  desc: "Attorney, paralegal, compliance" },
//   { value: "Education",                  icon: "🎓", desc: "Teaching, curriculum, administration" },
//   { value: "Human Resources",            icon: "👥", desc: "Recruiting, L&D, HR business partner" },
//   { value: "Engineering (Non-Software)", icon: "🔧", desc: "Mechanical, civil, electrical, chemical" },
//   { value: "Design / Creative",          icon: "🎨", desc: "UX/UI, graphic design, content creation" },
// ];

// // eslint-disable-next-line no-unused-vars
// const EXPERIENCE_LEVELS = [
//   { value: "0-1",  label: "0–1 years",   sub: "Entry level / Fresher" },
//   { value: "1-3",  label: "1–3 years",   sub: "Junior" },
//   { value: "3-5",  label: "3–5 years",   sub: "Mid level" },
//   { value: "5-8",  label: "5–8 years",   sub: "Senior" },
//   { value: "8-12", label: "8–12 years",  sub: "Lead / Principal" },
//   { value: "12+",  label: "12+ years",   sub: "Director / Executive" },
// ];

// // eslint-disable-next-line no-unused-vars
// const EDUCATION_LEVELS = [
//   "High School Diploma", "Associate Degree", "Bachelor's Degree",
//   "Master's Degree", "MBA", "PhD / Doctorate",
//   "Professional Certification", "Bootcamp / Self-taught",
// ];

// // eslint-disable-next-line no-unused-vars
// const STEPS = ["Domain", "Experience", "Job Details", "Template"];

// // ── Template card ──
// // eslint-disable-next-line no-unused-vars
// function TemplateCard({ template, selected, onSelect }) {
//   const { accent } = template;
//   return (
//     <div
//       onClick={() => onSelect(template.id)}
//       style={{
//         borderRadius: 12,
//         border: selected ? `2px solid ${accent}` : "1.5px solid #e2e8f0",
//         background: "#fff", cursor: "pointer", transition: "all 0.2s",
//         overflow: "hidden", position: "relative",
//         boxShadow: selected ? `0 6px 20px ${accent}28` : "0 1px 4px rgba(0,0,0,0.04)",
//         transform: selected ? "translateY(-2px) scale(1.01)" : "none",
//       }}
//       onMouseEnter={e => { if (!selected) { e.currentTarget.style.borderColor = accent; e.currentTarget.style.transform = "translateY(-1px)"; }}}
//       onMouseLeave={e => { if (!selected) { e.currentTarget.style.borderColor = "#e2e8f0"; e.currentTarget.style.transform = "none"; }}}
//     >
//       {selected && (
//         <div style={{ position: "absolute", top: 6, right: 6, background: accent, color: "#fff", fontSize: 9, fontWeight: 700, padding: "1px 7px", borderRadius: 20, zIndex: 3 }}>✓ Selected</div>
//       )}
//       <div style={{ background: "#f5f5f5", display: "flex", alignItems: "center", justifyContent: "center", padding: "10px 8px 6px" }}>
//         <TemplateMini t={template} scale={0.32} width={560} />
//       </div>
//       <div style={{ padding: "7px 10px 9px", borderTop: "1px solid #f1f5f9" }}>
//         <div style={{ fontWeight: 700, fontSize: 12, color: "#0f172a", marginBottom: 1 }}>{template.name}</div>
//         <div style={{ fontSize: 10, color: "#64748b", marginBottom: 4, lineHeight: 1.4 }}>{template.description}</div>
//         <div style={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
//           {template.tags.map(t => (
//             <span key={t} style={{ fontSize: 9, padding: "1px 5px", borderRadius: 20, background: `${accent}12`, color: accent, fontWeight: 600 }}>{t}</span>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// // ── Generation overlay steps ──
// const GEN_STEPS = [
//   { icon: "🎯", label: "Reading your job description" },
//   { icon: "✍️", label: "Building work experience" },
//   { icon: "🔑", label: "Injecting ATS keywords" },
//   { icon: "📐", label: "Applying your template" },
//   { icon: "✅", label: "Finalising your resume" },
// ];

// function GeneratingOverlay({ templateAccent }) {
//   const [active, setActive] = useState(0);
//   useEffect(() => {
//     const t = setInterval(() => setActive(p => p < GEN_STEPS.length - 1 ? p + 1 : p), 3500);
//     return () => clearInterval(t);
//   }, []);
//   return (
//     <div style={{ position: "fixed", inset: 0, zIndex: 1100, background: "rgba(15,23,42,0.78)", backdropFilter: "blur(6px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
//       <div style={{ background: "#fff", borderRadius: 24, padding: "48px 40px", maxWidth: 460, width: "100%", textAlign: "center", boxShadow: "0 24px 60px rgba(0,0,0,0.3)" }}>
//         <div style={{ position: "relative", width: 80, height: 80, margin: "0 auto 20px" }}>
//           <div style={{ width: 80, height: 80, borderRadius: "50%", border: "4px solid #e2e8f0", borderTopColor: templateAccent || "#2563eb", animation: "spin 0.8s linear infinite", position: "absolute", inset: 0 }} />
//           <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 28 }}>✨</div>
//         </div>
//         <h2 style={{ fontSize: 20, fontWeight: 800, color: "#1e293b", marginBottom: 8 }}>Building your resume...</h2>
//         <p style={{ fontSize: 14, color: "#64748b", marginBottom: 28, lineHeight: 1.6 }}>Our AI is creating a keyword-rich, ATS-optimized resume tailored to your job description.</p>
//         <div style={{ display: "flex", flexDirection: "column", gap: 8, textAlign: "left" }}>
//           {GEN_STEPS.map((s, i) => {
//             const done = i < active, isActive = i === active;
//             return (
//               <div key={s.label} style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 12px", borderRadius: 10, background: done ? "#f0fdf4" : isActive ? "#eff6ff" : "#f8fafc", border: `1px solid ${done ? "#bbf7d0" : isActive ? "#bfdbfe" : "#e2e8f0"}`, opacity: i > active + 1 ? 0.4 : 1 }}>
//                 <div style={{ width: 28, height: 28, borderRadius: "50%", background: done ? "#dcfce7" : isActive ? "#dbeafe" : "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", fontSize: done ? 12 : 14, flexShrink: 0 }}>
//                   {done ? "✓" : s.icon}
//                 </div>
//                 <span style={{ fontSize: 12, fontWeight: isActive ? 600 : 500, color: done ? "#059669" : isActive ? "#2563eb" : "#94a3b8" }}>{s.label}</span>
//                 {isActive && <div style={{ marginLeft: "auto", display: "flex", gap: 3 }}>{[0,1,2].map(d => <div key={d} style={{ width: 4, height: 4, borderRadius: "50%", background: "#2563eb", animation: `bounce 1s ease-in-out ${d * 0.2}s infinite` }} />)}</div>}
//                 {done && <span style={{ marginLeft: "auto", fontSize: 11, color: "#059669", fontWeight: 600 }}>Done</span>}
//               </div>
//             );
//           })}
//         </div>
//         <p style={{ fontSize: 12, color: "#94a3b8", marginTop: 24 }}>Usually takes 15–25 seconds</p>
//       </div>
//     </div>
//   );
// }

// export default function ResumeFromScratchPage() {
//   const { user, userData } = useAuth();
//   const navigate = useNavigate();

//   const [eligibility, setEligibility] = useState(null);
//   const [loading,     setLoading]     = useState(true);
//   // eslint-disable-next-line no-unused-vars
//   const [step,        setStep]        = useState(0); // 0-3 = wizard steps
//   const [generating,  setGenerating]  = useState(false);
//   const [generated,   setGenerated]   = useState(null);
//   // eslint-disable-next-line no-unused-vars
//   const [error,       setError]       = useState("");
//   const [pdfLoading,  setPdfLoading]  = useState(false);
//   const [downloaded,  setDownloaded]  = useState(false);
//   const previewRef = useRef();

//   // ── Form state ──
//   // eslint-disable-next-line no-unused-vars
//   const [domain,          setDomain]          = useState("");
//   // eslint-disable-next-line no-unused-vars
//   const [experienceYears, setExperienceYears] = useState("3-5");
//   // eslint-disable-next-line no-unused-vars
//   const [educationLevel,  setEducationLevel]  = useState("Bachelor's Degree");
//   // eslint-disable-next-line no-unused-vars
//   const [jobTitle,        setJobTitle]        = useState("");
//   // eslint-disable-next-line no-unused-vars
//   const [skills,          setSkills]          = useState("");
//   // eslint-disable-next-line no-unused-vars
//   const [extraInfo,       setExtraInfo]       = useState("");
//   // eslint-disable-next-line no-unused-vars
//   const [jobDescription,  setJobDescription]  = useState("");
//   // eslint-disable-next-line no-unused-vars
//   const [selectedTemplate, setSelectedTemplate] = useState("classic");
//   // eslint-disable-next-line no-unused-vars
//   const [fullName,         setFullName]         = useState("");

//   // ── Templates from plan ──
//   const planConfig  = servicesConfig.plans.find(p => p.id === "ats_basic");
//   const templates   = servicesConfig.resumeTemplates.filter(
//     t => t.active && !t.comingSoon && (planConfig?.resumeTemplateIds || []).includes(t.id)
//   );
//   const activeTemplate = templates.find(t => t.id === selectedTemplate) || templates[0];

//   useEffect(() => {
//     async function check() {
//       if (!user) return;
//       try {
//         const result = await getScratchResumeEligibility(user.uid);
//         setEligibility(result);
//         setFullName(`${userData?.firstName || ""} ${userData?.lastName || ""}`.trim());
//       } catch {
//         setEligibility({ eligible: false });
//       }
//       setLoading(false);
//     }
//     check();
//   }, [user, userData]);

//   // ── Step validation ──
//   // eslint-disable-next-line no-unused-vars
//   function canProceed() {
//     if (step === 0) return !!domain;
//     if (step === 1) return !!experienceYears && !!educationLevel;
//     if (step === 2) return jobDescription.trim().length >= 50;
//     return true;
//   }

// // eslint-disable-next-line no-unused-vars
//   async function handleGenerate() {
//   setError("");

//   // ── Hard re-check eligibility before calling the API ──
//   // Prevents double-generation if user opens two tabs or the local
//   // eligibility state is stale from a previous session
//   let freshCheck;
//   try {
//     freshCheck = await getScratchResumeEligibility(user.uid);
//   } catch (err) {
//     setError("Could not verify your plan eligibility. Please refresh and try again.");
//     return;
//   }

//   if (!freshCheck.eligible) {
//     setEligibility(freshCheck);
//     setError(
//       freshCheck.reason === "no_paid_plan"
//         ? "You need an active plan to use the Resume Builder. Purchase a plan from the dashboard."
//         : freshCheck.reason === "quota_exhausted"
//         ? `You've already used your ${freshCheck.allowed} free resume build for this plan. Purchase a new plan to generate another.`
//         : "Your plan doesn't include resume builder access. Please contact support if you think this is a mistake."
//     );
//     return;
//   }

//   setGenerating(true);

//   try {
//     // ── Call the scratch resume endpoint ──
//     const res = await fetch(`${apiConfig.BACKEND_URL}/generate-resume-scratch`, {
//       method:  "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         jobDescription,
//         templateId: selectedTemplate,
//         userInfo: {
//           name:            fullName || "Alex Johnson",
//           domain,
//           jobTitle,
//           experienceYears,
//           educationLevel,
//           skills,
//           extraInfo,
//         },
//       }),
//     });

//     if (!res.ok) {
//       const errData = await res.json().catch(() => ({ error: `Server error ${res.status}` }));
//       throw new Error(errData.error || `Generation failed (${res.status})`);
//     }

//     const resume = await res.json();

//     if (!resume || !resume.name) {
//       throw new Error("Resume generation returned incomplete data. Please try again.");
//     }

//     setGenerated(resume);

//     // ── Save resume to Firestore ──
//     // Do this BEFORE marking the transaction so if the mark fails,
//     // the legacy generatedDocs count fallback still catches it correctly
//     let savedDocId = null;
//     try {
//       savedDocId = await saveGeneratedResume(user.uid, {
//         resumeData:    resume,
//         templateId:    selectedTemplate,
//         transactionId: freshCheck.transactionId,
//         planId:        freshCheck.planId || "ats_basic",
//         mode:          "scratch",
//         domain,
//       });
//       console.log(`✅ Scratch resume saved to Firestore | doc=${savedDocId}`);
//     } catch (saveErr) {
//       // Log but don't block — user still gets the resume on screen
//       // They can download it now even if save failed
//       console.error("❌ Failed to save resume to Firestore:", saveErr.message);
//     }

//     // ── Mark the quota as used on the transaction ──
//     // This increments scratchResumeUsedCount atomically
//     // Runs even if saveGeneratedResume failed — prevents free re-generation
//     try {
//       await markScratchResumeGenerated(
//         user.uid,
//         freshCheck.transactionId,
//         selectedTemplate
//       );
//       console.log(`✅ Scratch quota marked used | tx=${freshCheck.transactionId}`);
//     } catch (markErr) {
//       // If this fails, the generatedDocs fallback count will still
//       // catch it on next eligibility check (if savedDocId exists)
//       console.error("❌ Failed to mark scratch resume on transaction:", markErr.message);
//     }

//     // ── Update local eligibility state to reflect used quota ──
//     setEligibility({
//       ...freshCheck,
//       eligible:  false,
//       used:      (freshCheck.used || 0) + 1,
//       remaining: Math.max(0, (freshCheck.remaining || 1) - 1),
//       reason:    "quota_exhausted",
//     });

//     // ── Scroll to preview ──
//     setTimeout(() => {
//       previewRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
//     }, 300);

//   } catch (err) {
//     console.error("❌ Scratch resume generation error:", err.message);

//     // Distinguish user-facing error messages by type
//     if (err.message?.includes("too long")) {
//       setError("Your job description is too long. Please shorten it and try again.");
//     } else if (err.message?.includes("too short")) {
//       setError("Your job description is too short. Please paste more of the job posting.");
//     } else if (err.message?.includes("Server error 5")) {
//       setError("Our AI service is temporarily unavailable. Please try again in a minute.");
//     } else {
//       setError(err.message || "Something went wrong generating your resume. Please try again.");
//     }

//     // Don't update eligibility on error — user should be able to retry
//   } finally {
//     setGenerating(false);
//   }
// }

//   async function handleDownload(format) {
//     if (!generated) return;
//     const base = `${activeTemplate.name}-Resume-${(fullName || "Resume").replace(/\s+/g, "-")}`;
//     try {
//       if (format === "pdf") {
//         setPdfLoading(true);
//         await downloadResumeAsPDF(generated, `${base}.pdf`, selectedTemplate);
//         setPdfLoading(false);
//       } else if (format === "word") {
//         await downloadResumeAsWord(generated, `${base}.docx`, selectedTemplate);
//       } else {
//         downloadATSResume(generated, `${base}.html`, selectedTemplate);
//       }
//       setDownloaded(true);
//     } catch (err) {
//       setPdfLoading(false);
//       setError("Download failed. Please try again.");
//     }
//   }

//   if (loading) return (
//     <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
//       <div style={{ textAlign: "center" }}>
//         <div style={{ width: 36, height: 36, borderRadius: "50%", border: "3px solid #e2e8f0", borderTopColor: "#2563eb", animation: "spin 0.7s linear infinite", margin: "0 auto 12px" }} />
//         <p style={{ fontSize: 14, color: "#64748b" }}>Checking your access...</p>
//         <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
//       </div>
//     </div>
//   );

//   return (
//     <div style={{ minHeight: "100vh", background: "#f8fafc", fontFamily: "'Inter', -apple-system, sans-serif" }}>
//       <style>{`
//         *, *::before, *::after { box-sizing: border-box; }
//         @keyframes spin   { to { transform: rotate(360deg); } }
//         @keyframes bounce { 0%,100%{transform:translateY(0);opacity:0.4} 50%{transform:translateY(-4px);opacity:1} }
//         @media (max-width:600px) {
//           .rfs-tmpl-grid { grid-template-columns: repeat(2,1fr) !important; }
//           .rfs-domain-grid { grid-template-columns: 1fr !important; }
//           .rfs-dl-grid { grid-template-columns: 1fr !important; }
//         }
//       `}</style>

//       {generating && <GeneratingOverlay templateAccent={activeTemplate?.accent} />}

//       {/* Nav */}
//       <nav style={{ borderBottom: "1px solid #e2e8f0", padding: "0 28px", height: 60, display: "flex", alignItems: "center", justifyContent: "space-between", background: "#fff", position: "sticky", top: 0, zIndex: 100 }}>
//         <Link to="/dashboard" style={{ display: "flex", alignItems: "center", gap: 8, textDecoration: "none" }}>
//           <div style={{ width: 30, height: 30, background: "linear-gradient(135deg,#2563eb,#1d4ed8)", borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center" }}>
//             <span style={{ color: "#fff", fontSize: 14 }}>R</span>
//           </div>
//           <span style={{ fontWeight: 700, fontSize: 16, color: "#1e293b" }}>ResumeScore<span style={{ color: "#2563eb" }}>AI</span></span>
//         </Link>
//         <button onClick={() => navigate("/dashboard")} style={{ fontSize: 13, padding: "6px 14px", background: "transparent", border: "1px solid #e2e8f0", borderRadius: 8, cursor: "pointer", color: "#475569" }}>← Back</button>
//       </nav>

//       <div style={{ flex: 1, maxWidth: 720, margin: "0 auto", padding: "32px 20px", width: "100%" }}>

//         {/* Header */}
//         <div style={{ marginBottom: 28 }}>
//           <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6, flexWrap: "wrap" }}>
//             <h1 style={{ fontSize: 24, fontWeight: 800, color: "#0f172a", letterSpacing: "-0.02em" }}>Resume Builder</h1>
//             <span style={{ background: "#EAF3DE", color: "#3B6D11", fontSize: 12, fontWeight: 700, padding: "3px 10px", borderRadius: 20 }}>FREE with your plan</span>
//           </div>
//           <p style={{ fontSize: 14, color: "#64748b" }}>Don't have a resume yet? Tell us about yourself and we'll build one tailored to the job you're going for.</p>
//         </div>

//         {/* Not eligible */}
//         {!eligibility?.eligible && !generated && (
//           <div style={{ background: "#fff", borderRadius: 16, border: "1px solid #e2e8f0", padding: "32px", textAlign: "center" }}>
//             <div style={{ fontSize: 44, marginBottom: 12 }}>
//               {eligibility?.reason === "quota_exhausted" ? "🎉" : "🔒"}
//             </div>

//             <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 10, color: "#0f172a" }}>
//               {eligibility?.reason === "quota_exhausted"
//                 ? "You've used your free resume build"
//                 : "Unlock the Resume Builder"}
//             </h2>

//             <p style={{ fontSize: 14, color: "#64748b", maxWidth: 420, margin: "0 auto 8px", lineHeight: 1.7 }}>
//               {eligibility?.reason === "quota_exhausted"
//                 ? `Your current plan included ${eligibility.allowed === 1 ? "1 free resume build" : `${eligibility.allowed} free resume builds`} — and you've used ${eligibility.used === eligibility.allowed ? (eligibility.allowed === 1 ? "it" : "all of them") : `${eligibility.used}`}.`
//                 : "The Resume Builder is included free with your ATS Basic plan."}
//             </p>

//             {eligibility?.reason === "quota_exhausted" && (
//               <div style={{
//                 background: "#f0fdf4", border: "1px solid #bbf7d0",
//                 borderRadius: 12, padding: "14px 20px",
//                 maxWidth: 380, margin: "0 auto 20px",
//                 fontSize: 13, color: "#166534", lineHeight: 1.7,
//               }}>
//                 <strong>Good news:</strong> buying a new plan gives you another free build.
//                 Your previously generated resume is still available to download from{" "}
//                 <button
//                   onClick={() => navigate("/account")}
//                   style={{ background: "none", border: "none", color: "#059669", fontWeight: 700, cursor: "pointer", fontSize: 13, textDecoration: "underline", padding: 0 }}
//                 >
//                   My Documents
//                 </button>.
//               </div>
//             )}

//             {eligibility?.reason !== "quota_exhausted" && (
//               <p style={{ fontSize: 13, color: "#94a3b8", maxWidth: 380, margin: "0 auto 20px", lineHeight: 1.6 }}>
//                 Pick your field, experience level, and a job description — we'll build a professional ATS resume from scratch, no existing resume needed.
//               </p>
//             )}

//             <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
//               <button
//                 onClick={() => navigate("/dashboard")}
//                 style={{ padding: "11px 24px", background: "linear-gradient(135deg,#2563eb,#1d4ed8)", color: "#fff", border: "none", borderRadius: 10, fontWeight: 700, fontSize: 14, cursor: "pointer" }}
//               >
//                 💳 {eligibility?.reason === "quota_exhausted" ? "Buy a New Plan" : `Get ATS Basic — ${planConfig?.price || "$4.99"}`}
//               </button>
//               <button
//                 onClick={() => navigate("/account")}
//                 style={{ padding: "11px 20px", background: "transparent", color: "#475569", border: "1px solid #e2e8f0", borderRadius: 10, fontWeight: 600, fontSize: 13, cursor: "pointer" }}
//               >
//                 View My Documents
//               </button>
//             </div>
//           </div>
//         )}

//         {/* Wizard */}
//         {/* Replace the existing green eligible banner with this: */}
//         {eligibility?.eligible && !generated && (
//         <div style={{ background: "#EAF3DE", border: "1px solid #C0DD97", borderRadius: 10, padding: "14px 18px", marginBottom: 20, display: "flex", alignItems: "center", gap: 12 }}>
//             <span style={{ fontSize: 22 }}>🎁</span>
//             <div>
//             <div style={{ fontWeight: 700, fontSize: 14, color: "#3B6D11" }}>
//                 {eligibility.remaining || 1} free resume build available with your plan
//             </div>
//             <div style={{ fontSize: 12, color: "#3B6D11", marginTop: 2 }}>
//                 Used {eligibility.used || 0} of {eligibility.allowed || 1} · Resets when you purchase a new plan
//             </div>
//             </div>
//         </div>
//         )}

//         {/* ── Generated result ── */}
//         {generated && (
//           <div ref={previewRef}>
//             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20, flexWrap: "wrap", gap: 12 }}>
//               <div>
//                 <h2 style={{ fontSize: 20, fontWeight: 800, color: "#0f172a", marginBottom: 4 }}>Your resume is ready 🎉</h2>
//                 <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                   <span style={{ fontSize: 13, color: "#64748b" }}>Styled with</span>
//                   <span style={{ fontSize: 12, fontWeight: 700, padding: "2px 10px", borderRadius: 20, background: `${activeTemplate.accent}12`, color: activeTemplate.accent, border: `1px solid ${activeTemplate.accent}25` }}>{activeTemplate.name}</span>
//                   <span style={{ fontSize: 12, background: "#EAF3DE", color: "#3B6D11", padding: "2px 9px", borderRadius: 20, fontWeight: 600 }}>{domain}</span>
//                 </div>
//               </div>
//               <button onClick={() => navigate("/dashboard")} style={{ padding: "8px 16px", background: "transparent", border: "1px solid #e2e8f0", borderRadius: 9, fontSize: 13, color: "#475569", cursor: "pointer", fontWeight: 500 }}>
//                 Back to Dashboard
//               </button>
//             </div>

//             {/* Warning */}
//             <div style={{ background: "#FCEBEB", border: "2px solid #f0a0a0", borderRadius: 12, padding: "13px 16px", marginBottom: 16 }}>
//               <div style={{ display: "flex", gap: 10 }}>
//                 <span style={{ fontSize: 18, flexShrink: 0 }}>⚠️</span>
//                 <p style={{ fontSize: 13, color: "#A32D2D", margin: 0, lineHeight: 1.7 }}>
//                   <strong>Before you send this out:</strong> replace the fictional companies, dates, and contact details with your real ones. The structure and keywords are ready — the details need to be yours.
//                 </p>
//               </div>
//             </div>

//             {/* Downloads */}
//             <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", padding: "20px", marginBottom: 20 }}>
//               <div style={{ fontSize: 14, fontWeight: 700, color: "#0f172a", marginBottom: 4 }}>⬇ Download your resume</div>
//               <p style={{ fontSize: 12, color: "#64748b", marginBottom: 14 }}>PDF is recommended for job applications — it preserves all formatting.</p>
//               <div className="rfs-dl-grid" style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10 }}>
//                 {[
//                   { f: "pdf",  icon: pdfLoading ? "⏳" : "📄", label: pdfLoading ? "Generating..." : "PDF",  sub: "✅ Recommended", primary: true  },
//                   { f: "html", icon: "🌐",                      label: "HTML",                               sub: "Print in browser", primary: false },
//                   { f: "word", icon: "📝",                      label: "Word",                               sub: "Editable .docx",   primary: false },
//                 ].map(b => (
//                   <button key={b.f} onClick={() => handleDownload(b.f)}
//                     style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4, padding: "13px 10px", borderRadius: 10, border: b.primary ? "none" : "1.5px solid #e2e8f0", background: b.primary ? `linear-gradient(135deg,${activeTemplate.accent},${activeTemplate.headerBg})` : "#fff", color: b.primary ? "#fff" : "#475569", cursor: "pointer", position: "relative", fontWeight: b.primary ? 700 : 600, fontSize: 13, transition: "all 0.15s" }}>
//                     {b.primary && <span style={{ position: "absolute", top: -8, right: -4, fontSize: 9, fontWeight: 800, background: "#059669", color: "#fff", padding: "2px 6px", borderRadius: 20 }}>Best</span>}
//                     <span style={{ fontSize: 22 }}>{b.icon}</span>
//                     <span>{b.label}</span>
//                     <span style={{ fontSize: 10, opacity: 0.75 }}>{b.sub}</span>
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {/* Preview */}
//             <div style={{ background: "#e8e8e8", padding: "24px 16px", borderRadius: 12, marginBottom: 20 }}>
//               <div style={{ maxWidth: 860, margin: "0 auto", position: "relative" }}>
//                 <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%) rotate(-35deg)", fontSize: 80, fontWeight: 900, color: "rgba(0,0,0,0.04)", pointerEvents: "none", whiteSpace: "nowrap", zIndex: 10, userSelect: "none" }}>SAMPLE</div>
//                 <div style={{ background: "#fff", borderRadius: 4, boxShadow: "0 8px 32px rgba(0,0,0,0.15)", overflow: "hidden", position: "relative" }}>
//                   <iframe title="Resume Preview"
//                     srcDoc={buildResumeHTML(generated, selectedTemplate, { showHint: false })}
//                     style={{ width: "794px", border: "none", display: "block", minHeight: "1000px", transformOrigin: "top left" }}
//                     scrolling="no"
//                     onLoad={e => {
//                       try {
//                         const iframe = e.target, container = iframe.parentElement;
//                         const h = iframe.contentDocument?.documentElement?.scrollHeight || 1000;
//                         iframe.style.height = h + "px";
//                         const scale = Math.min(1, (container.offsetWidth || 794) / 794);
//                         iframe.style.transform = `scale(${scale})`;
//                         iframe.style.transformOrigin = "top left";
//                         container.style.height = Math.round(h * scale) + "px";
//                       } catch (_) {}
//                     }}
//                   />
//                 </div>
//               </div>
//             </div>

//             {/* Bottom actions */}
//             <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
//               <button onClick={() => handleDownload("pdf")} disabled={pdfLoading}
//                 style={{ padding: "11px 24px", background: `linear-gradient(135deg,${activeTemplate.accent},${activeTemplate.headerBg})`, color: "#fff", border: "none", borderRadius: 10, fontWeight: 700, fontSize: 13, cursor: pdfLoading ? "not-allowed" : "pointer" }}>
//                 {pdfLoading ? "⏳ Generating..." : "📄 Download PDF"}
//               </button>
//               <button onClick={() => navigate("/dashboard")}
//                 style={{ padding: "11px 20px", background: "transparent", color: "#475569", border: "1.5px solid #e2e8f0", borderRadius: 10, fontWeight: 600, fontSize: 13, cursor: "pointer" }}>
//                 Back to Dashboard
//               </button>
//             </div>
//             {downloaded && <p style={{ textAlign: "center", fontSize: 12, color: "#94a3b8", marginTop: 10 }}>✅ Downloaded. Remember to personalise with your real details before applying.</p>}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

//new code by deep seek.
import { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { getScratchResumeEligibility, markScratchResumeGenerated, saveGeneratedResume } from "../utils/transactions";
import { downloadATSResume, downloadResumeAsWord, downloadResumeAsPDF, buildResumeHTML } from "../utils/generateResumeDoc";
// eslint-disable-next-line no-unused-vars
import servicesConfig from "../utils/servicesConfig";
import apiConfig from "../utils/apiConfig";
import TemplateMini from "../components/TemplateMini";

// Domain options
const DOMAINS = [
  { value: "Technology / Software",     icon: "💻", desc: "Software, engineering, data, DevOps" },
  { value: "Healthcare / Medical",       icon: "🏥", desc: "Nursing, clinical, pharmacy, allied health" },
  { value: "Finance / Banking",          icon: "📈", desc: "Accounting, investment, insurance, banking" },
  { value: "Marketing / Sales",          icon: "📣", desc: "Digital marketing, sales, PR, brand" },
  { value: "Operations / Logistics",     icon: "⚙️",  desc: "Supply chain, manufacturing, project mgmt" },
  { value: "Legal",                      icon: "⚖️",  desc: "Attorney, paralegal, compliance" },
  { value: "Education",                  icon: "🎓", desc: "Teaching, curriculum, administration" },
  { value: "Human Resources",            icon: "👥", desc: "Recruiting, L&D, HR business partner" },
  { value: "Engineering (Non-Software)", icon: "🔧", desc: "Mechanical, civil, electrical, chemical" },
  { value: "Design / Creative",          icon: "🎨", desc: "UX/UI, graphic design, content creation" },
];

const EXPERIENCE_LEVELS = [
  { value: "0-1",  label: "0–1 years",   sub: "Entry level / Fresher" },
  { value: "1-3",  label: "1–3 years",   sub: "Junior" },
  { value: "3-5",  label: "3–5 years",   sub: "Mid level" },
  { value: "5-8",  label: "5–8 years",   sub: "Senior" },
  { value: "8-12", label: "8–12 years",  sub: "Lead / Principal" },
  { value: "12+",  label: "12+ years",   sub: "Director / Executive" },
];

const EDUCATION_LEVELS = [
  "High School Diploma", "Associate Degree", "Bachelor's Degree",
  "Master's Degree", "MBA", "PhD / Doctorate",
  "Professional Certification", "Bootcamp / Self-taught",
];

const TEMPLATES = [
  { id: "classic", name: "Classic", accent: "#2563EB", headerBg: "#1E293B", description: "Traditional, ATS-friendly layout", tags: ["Safe", "Corporate"] },
  { id: "professional", name: "Professional", accent: "#1E3A5F", headerBg: "#0F172A", description: "Clean, modern, recruiter-approved", tags: ["Clean", "Modern"] },
  { id: "minimal", name: "Minimal", accent: "#047857", headerBg: "#064E3B", description: "Simple, elegant, focus on content", tags: ["Simple", "Elegant"] },
  { id: "executive", name: "Executive", accent: "#334155", headerBg: "#0F172A", description: "Senior-level, boardroom ready", tags: ["Executive", "Bold"] },
  { id: "bold", name: "Bold", accent: "#1D4ED8", headerBg: "#1E3A8A", description: "High-impact, stands out", tags: ["Impact", "Modern"] },
];

const GEN_STEPS = [
  { icon: "🎯", label: "Reading your job description" },
  { icon: "✍️", label: "Building work experience" },
  { icon: "🔑", label: "Injecting ATS keywords" },
  { icon: "📐", label: "Applying your template" },
  { icon: "✅", label: "Finalising your resume" },
];

function GeneratingOverlay({ templateAccent }) {
  const [active, setActive] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setActive(p => p < GEN_STEPS.length - 1 ? p + 1 : p), 3500);
    return () => clearInterval(t);
  }, []);
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 1100, background: "rgba(15,23,42,0.78)", backdropFilter: "blur(6px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <div style={{ background: "#fff", borderRadius: 24, padding: "48px 40px", maxWidth: 460, width: "100%", textAlign: "center", boxShadow: "0 24px 60px rgba(0,0,0,0.3)" }}>
        <div style={{ position: "relative", width: 80, height: 80, margin: "0 auto 20px" }}>
          <div style={{ width: 80, height: 80, borderRadius: "50%", border: "4px solid #e2e8f0", borderTopColor: templateAccent || "#2563eb", animation: "spin 0.8s linear infinite", position: "absolute", inset: 0 }} />
          <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 28 }}>✨</div>
        </div>
        <h2 style={{ fontSize: 20, fontWeight: 800, color: "#1e293b", marginBottom: 8 }}>Building your resume...</h2>
        <p style={{ fontSize: 14, color: "#64748b", marginBottom: 28, lineHeight: 1.6 }}>Our AI is creating a keyword-rich, ATS-optimized resume tailored to your job description.</p>
        <div style={{ display: "flex", flexDirection: "column", gap: 8, textAlign: "left" }}>
          {GEN_STEPS.map((s, i) => {
            const done = i < active, isActive = i === active;
            return (
              <div key={s.label} style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 12px", borderRadius: 10, background: done ? "#f0fdf4" : isActive ? "#eff6ff" : "#f8fafc", border: `1px solid ${done ? "#bbf7d0" : isActive ? "#bfdbfe" : "#e2e8f0"}`, opacity: i > active + 1 ? 0.4 : 1 }}>
                <div style={{ width: 28, height: 28, borderRadius: "50%", background: done ? "#dcfce7" : isActive ? "#dbeafe" : "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", fontSize: done ? 12 : 14, flexShrink: 0 }}>
                  {done ? "✓" : s.icon}
                </div>
                <span style={{ fontSize: 12, fontWeight: isActive ? 600 : 500, color: done ? "#059669" : isActive ? "#2563eb" : "#94a3b8" }}>{s.label}</span>
                {isActive && <div style={{ marginLeft: "auto", display: "flex", gap: 3 }}>{[0,1,2].map(d => <div key={d} style={{ width: 4, height: 4, borderRadius: "50%", background: "#2563eb", animation: `bounce 1s ease-in-out ${d * 0.2}s infinite` }} />)}</div>}
                {done && <span style={{ marginLeft: "auto", fontSize: 11, color: "#059669", fontWeight: 600 }}>Done</span>}
              </div>
            );
          })}
        </div>
        <p style={{ fontSize: 12, color: "#94a3b8", marginTop: 24 }}>Usually takes 15–25 seconds</p>
      </div>
    </div>
  );
}

function TemplateCard({ template, selected, onSelect }) {
  const { accent } = template;
  return (
    <div
      onClick={() => onSelect(template.id)}
      style={{
        borderRadius: 12,
        border: selected ? `2px solid ${accent}` : "1.5px solid #e2e8f0",
        background: "#fff", cursor: "pointer", transition: "all 0.2s",
        overflow: "hidden", position: "relative",
        boxShadow: selected ? `0 6px 20px ${accent}28` : "0 1px 4px rgba(0,0,0,0.04)",
        transform: selected ? "translateY(-2px) scale(1.01)" : "none",
      }}
    >
      {selected && (
        <div style={{ position: "absolute", top: 6, right: 6, background: accent, color: "#fff", fontSize: 9, fontWeight: 700, padding: "1px 7px", borderRadius: 20, zIndex: 3 }}>✓ Selected</div>
      )}
      <div style={{ background: "#f5f5f5", display: "flex", alignItems: "center", justifyContent: "center", padding: "10px 8px 6px" }}>
        <TemplateMini t={template} scale={0.32} width={560} />
      </div>
      <div style={{ padding: "7px 10px 9px", borderTop: "1px solid #f1f5f9" }}>
        <div style={{ fontWeight: 700, fontSize: 12, color: "#0f172a", marginBottom: 1 }}>{template.name}</div>
        <div style={{ fontSize: 10, color: "#64748b", marginBottom: 4, lineHeight: 1.4 }}>{template.description}</div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
          {template.tags.map(t => (
            <span key={t} style={{ fontSize: 9, padding: "1px 5px", borderRadius: 20, background: `${accent}12`, color: accent, fontWeight: 600 }}>{t}</span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default function ResumeFromScratchPage() {
  const { user, userData } = useAuth();
  const navigate = useNavigate();

  const [eligibility, setEligibility] = useState(null);
  const [loading, setLoading] = useState(true);
  const [generating, setGenerating] = useState(false);
  const [generated, setGenerated] = useState(null);
  const [error, setError] = useState("");
  const [pdfLoading, setPdfLoading] = useState(false);
  const [downloaded, setDownloaded] = useState(false);
  const previewRef = useRef();

  // Form state
  const [domain, setDomain] = useState("");
  const [experienceYears, setExperienceYears] = useState("3-5");
  const [educationLevel, setEducationLevel] = useState("Bachelor's Degree");
  const [jobTitle, setJobTitle] = useState("");
  const [skills, setSkills] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [extraInfo, setExtraInfo] = useState("");
  const [jobDescription, setJobDescription] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState("classic");
  const [fullName, setFullName] = useState("");

  const activeTemplate = TEMPLATES.find(t => t.id === selectedTemplate) || TEMPLATES[0];

  // Check eligibility on load
  useEffect(() => {
    async function check() {
      if (!user) return;
      try {
        const result = await getScratchResumeEligibility(user.uid);
        console.log("Eligibility result:", result);
        setEligibility(result);
        setFullName(`${userData?.firstName || ""} ${userData?.lastName || ""}`.trim());
      } catch (err) {
        console.error("Eligibility check error:", err);
        setEligibility({ eligible: false });
      }
      setLoading(false);
    }
    check();
  }, [user, userData]);

  async function handleGenerate() {
    setError("");

    if (!jobDescription.trim() || jobDescription.trim().length < 50) {
      setError("Please paste a job description (minimum 50 characters).");
      return;
    }

    if (!domain) {
      setError("Please select your industry/domain.");
      return;
    }

    // Re-check eligibility before generating
    let freshCheck;
    try {
      freshCheck = await getScratchResumeEligibility(user.uid);
    } catch (err) {
      setError("Could not verify your plan eligibility. Please refresh and try again.");
      return;
    }

    if (!freshCheck.eligible) {
      setEligibility(freshCheck);
      setError(
        freshCheck.reason === "no_paid_plan"
          ? "You need an active plan to use the Resume Builder."
          : freshCheck.reason === "quota_exhausted"
          ? "You've used your free resume build for this plan."
          : "Your plan doesn't include resume builder access."
      );
      return;
    }

    setGenerating(true);

    try {
      const res = await fetch(`${apiConfig.BACKEND_URL}/generate-resume-scratch`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          jobDescription,
          templateId: selectedTemplate,
          userInfo: {
            name: fullName || "Alex Johnson",
            domain,
            jobTitle,
            experienceYears,
            educationLevel,
            skills,
            extraInfo,
          },
        }),
      });

      if (!res.ok) {
        const errData = await res.json().catch(() => ({ error: `Server error ${res.status}` }));
        throw new Error(errData.error || `Generation failed (${res.status})`);
      }

      const resume = await res.json();

      if (!resume || !resume.name) {
        throw new Error("Resume generation returned incomplete data.");
      }

      setGenerated(resume);

      // Save to Firestore
      try {
        await saveGeneratedResume(user.uid, {
          resumeData: resume,
          templateId: selectedTemplate,
          transactionId: freshCheck.transactionId,
          planId: freshCheck.planId || "ats_basic",
          mode: "scratch",
          domain,
        });
      } catch (saveErr) {
        console.error("Failed to save resume:", saveErr.message);
      }

      // Mark quota as used
      try {
        await markScratchResumeGenerated(user.uid, freshCheck.transactionId, selectedTemplate);
      } catch (markErr) {
        console.error("Failed to mark quota:", markErr.message);
      }

      // Update local eligibility
      setEligibility({
        ...freshCheck,
        eligible: false,
        used: (freshCheck.used || 0) + 1,
        remaining: Math.max(0, (freshCheck.remaining || 1) - 1),
      });

      setTimeout(() => {
        previewRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 300);

    } catch (err) {
      console.error("Generation error:", err.message);
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setGenerating(false);
    }
  }

  async function handleDownload(format) {
    if (!generated) return;
    const base = `${activeTemplate.name}-Resume-${(fullName || "Resume").replace(/\s+/g, "-")}`;
    try {
      if (format === "pdf") {
        setPdfLoading(true);
        await downloadResumeAsPDF(generated, `${base}.pdf`, selectedTemplate);
        setPdfLoading(false);
      } else if (format === "word") {
        await downloadResumeAsWord(generated, `${base}.docx`, selectedTemplate);
      } else {
        downloadATSResume(generated, `${base}.html`, selectedTemplate);
      }
      setDownloaded(true);
    } catch (err) {
      setPdfLoading(false);
      setError("Download failed. Please try again.");
    }
  }

  if (loading) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ width: 36, height: 36, borderRadius: "50%", border: "3px solid #e2e8f0", borderTopColor: "#2563eb", animation: "spin 0.7s linear infinite", margin: "0 auto 12px" }} />
        <p style={{ fontSize: 14, color: "#64748b" }}>Checking your access...</p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc", fontFamily: "'Inter', -apple-system, sans-serif" }}>
      <style>{`
        *, *::before, *::after { box-sizing: border-box; }
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes bounce { 0%,100%{transform:translateY(0);opacity:0.4} 50%{transform:translateY(-4px);opacity:1} }
        textarea, input, select { font-family: inherit; }
      `}</style>

      {generating && <GeneratingOverlay templateAccent={activeTemplate?.accent} />}

      {/* Nav */}
      <nav style={{ borderBottom: "1px solid #e2e8f0", padding: "0 28px", height: 60, display: "flex", alignItems: "center", justifyContent: "space-between", background: "#fff", position: "sticky", top: 0, zIndex: 100 }}>
        <Link to="/dashboard" style={{ display: "flex", alignItems: "center", gap: 8, textDecoration: "none" }}>
          <div style={{ width: 30, height: 30, background: "linear-gradient(135deg,#2563eb,#1d4ed8)", borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span style={{ color: "#fff", fontSize: 14 }}>R</span>
          </div>
          <span style={{ fontWeight: 700, fontSize: 16, color: "#1e293b" }}>ResumeScore<span style={{ color: "#2563eb" }}>AI</span></span>
        </Link>
        <button onClick={() => navigate("/dashboard")} style={{ fontSize: 13, padding: "6px 14px", background: "transparent", border: "1px solid #e2e8f0", borderRadius: 8, cursor: "pointer", color: "#475569" }}>← Back</button>
      </nav>

      <div style={{ flex: 1, maxWidth: 720, margin: "0 auto", padding: "32px 20px", width: "100%" }}>

        {/* Header */}
        <div style={{ marginBottom: 28 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6, flexWrap: "wrap" }}>
            <h1 style={{ fontSize: 24, fontWeight: 800, color: "#0f172a", letterSpacing: "-0.02em" }}>Resume Builder</h1>
            <span style={{ background: "#EAF3DE", color: "#3B6D11", fontSize: 12, fontWeight: 700, padding: "3px 10px", borderRadius: 20 }}>FREE with your plan</span>
          </div>
          <p style={{ fontSize: 14, color: "#64748b" }}>Don't have a resume yet? Tell us about yourself and we'll build one tailored to the job you're going for.</p>
        </div>

        {/* Eligibility Banner */}
        {eligibility?.eligible && !generated && (
          <div style={{ background: "#EAF3DE", border: "1px solid #C0DD97", borderRadius: 10, padding: "14px 18px", marginBottom: 20, display: "flex", alignItems: "center", gap: 12 }}>
            <span style={{ fontSize: 22 }}>🎁</span>
            <div>
              <div style={{ fontWeight: 700, fontSize: 14, color: "#3B6D11" }}>
                {eligibility.remaining || 1} free resume build{eligibility.remaining !== 1 ? 's' : ''} available
              </div>
              <div style={{ fontSize: 12, color: "#3B6D11", marginTop: 2 }}>
                Used {eligibility.used || 0} of {eligibility.allowed || 1}
              </div>
            </div>
          </div>
        )}

        {/* Not Eligible Banner */}
        {!eligibility?.eligible && !generated && eligibility !== null && (
          <div style={{ background: "#fff", borderRadius: 16, border: "1px solid #e2e8f0", padding: "32px", textAlign: "center" }}>
            <div style={{ fontSize: 44, marginBottom: 12 }}>
              {eligibility?.reason === "quota_exhausted" ? "🎉" : "🔒"}
            </div>
            <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 10, color: "#0f172a" }}>
              {eligibility?.reason === "quota_exhausted"
                ? "You've used your free resume build"
                : "Unlock the Resume Builder"}
            </h2>
            <p style={{ fontSize: 14, color: "#64748b", maxWidth: 420, margin: "0 auto 8px", lineHeight: 1.7 }}>
              {eligibility?.reason === "quota_exhausted"
                ? `Your current plan included ${eligibility.allowed === 1 ? "1 free resume build" : `${eligibility.allowed} free resume builds`}.`
                : "The Resume Builder is included free with your ATS Basic plan."}
            </p>
            <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap", marginTop: 20 }}>
              <button onClick={() => navigate("/dashboard")} style={{ padding: "11px 24px", background: "linear-gradient(135deg,#2563eb,#1d4ed8)", color: "#fff", border: "none", borderRadius: 10, fontWeight: 700, fontSize: 14, cursor: "pointer" }}>
                {eligibility?.reason === "quota_exhausted" ? "Buy a New Plan" : "View Plans"}
              </button>
            </div>
          </div>
        )}

        {/* ★★★★★ THE MISSING WIZARD FORM ★★★★★ */}
        {eligibility?.eligible && !generated && (
          <div>
            {/* Error message */}
            {error && (
              <div style={{ background: "#FCEBEB", border: "1px solid #f0a0a0", borderRadius: 10, padding: "12px 16px", marginBottom: 20 }}>
                <p style={{ fontSize: 13, color: "#A32D2D", margin: 0 }}>⚠️ {error}</p>
              </div>
            )}

            {/* Domain Selection */}
            <div style={{ background: "#fff", borderRadius: 16, border: "1px solid #e2e8f0", padding: "24px", marginBottom: 20 }}>
              <label style={{ fontWeight: 700, fontSize: 15, color: "#0f172a", marginBottom: 6, display: "block" }}>
                What industry or field are you in? <span style={{ color: "#ef4444" }}>*</span>
              </label>
              <p style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>This helps us tailor job titles and keywords.</p>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 10 }}>
                {DOMAINS.map(d => (
                  <button
                    key={d.value}
                    onClick={() => setDomain(d.value)}
                    style={{
                      display: "flex", alignItems: "center", gap: 10, padding: "12px 14px",
                      background: domain === d.value ? `${activeTemplate.accent}10` : "#fff",
                      border: domain === d.value ? `2px solid ${activeTemplate.accent}` : "1.5px solid #e2e8f0",
                      borderRadius: 10, cursor: "pointer", textAlign: "left",
                      transition: "all 0.15s",
                    }}
                  >
                    <span style={{ fontSize: 24 }}>{d.icon}</span>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 13, color: "#0f172a" }}>{d.value}</div>
                      <div style={{ fontSize: 11, color: "#64748b" }}>{d.desc}</div>
                    </div>
                  </button>
                ))}
              </div>
            </div>

            {/* Experience & Education */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 20 }}>
              <div style={{ background: "#fff", borderRadius: 16, border: "1px solid #e2e8f0", padding: "20px" }}>
                <label style={{ fontWeight: 700, fontSize: 14, color: "#0f172a", marginBottom: 12, display: "block" }}>Experience Level</label>
                <select
                  value={experienceYears}
                  onChange={(e) => setExperienceYears(e.target.value)}
                  style={{ width: "100%", padding: "10px 12px", border: "1.5px solid #e2e8f0", borderRadius: 8, fontSize: 13, background: "#fff" }}
                >
                  {EXPERIENCE_LEVELS.map(lvl => (
                    <option key={lvl.value} value={lvl.value}>{lvl.label} — {lvl.sub}</option>
                  ))}
                </select>
              </div>
              <div style={{ background: "#fff", borderRadius: 16, border: "1px solid #e2e8f0", padding: "20px" }}>
                <label style={{ fontWeight: 700, fontSize: 14, color: "#0f172a", marginBottom: 12, display: "block" }}>Education Level</label>
                <select
                  value={educationLevel}
                  onChange={(e) => setEducationLevel(e.target.value)}
                  style={{ width: "100%", padding: "10px 12px", border: "1.5px solid #e2e8f0", borderRadius: 8, fontSize: 13, background: "#fff" }}
                >
                  {EDUCATION_LEVELS.map(lvl => (
                    <option key={lvl} value={lvl}>{lvl}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Job Title & Skills */}
            <div style={{ background: "#fff", borderRadius: 16, border: "1px solid #e2e8f0", padding: "24px", marginBottom: 20 }}>
              <label style={{ fontWeight: 700, fontSize: 14, color: "#0f172a", marginBottom: 6, display: "block" }}>Target Job Title (optional)</label>
              <input
                type="text"
                value={jobTitle}
                onChange={(e) => setJobTitle(e.target.value)}
                placeholder="e.g., Senior Software Engineer, Product Manager, Data Analyst"
                style={{ width: "100%", padding: "10px 12px", border: "1.5px solid #e2e8f0", borderRadius: 8, fontSize: 13, marginBottom: 16 }}
              />
              <label style={{ fontWeight: 700, fontSize: 14, color: "#0f172a", marginBottom: 6, display: "block" }}>Key Skills (comma separated)</label>
              <input
                type="text"
                value={skills}
                onChange={(e) => setSkills(e.target.value)}
                placeholder="e.g., Python, Project Management, Data Analysis, AWS"
                style={{ width: "100%", padding: "10px 12px", border: "1.5px solid #e2e8f0", borderRadius: 8, fontSize: 13 }}
              />
            </div>

            {/* Job Description (CRITICAL) */}
            <div style={{ 
              background: "#fff", 
              borderRadius: 24, 
              border: "1px solid #e2e8f0", 
              padding: "28px", 
              marginBottom: 24,
              boxShadow: "0 4px 20px rgba(0,0,0,0.02)",
              transition: "all 0.2s ease"
            }}>
              {/* Header with icon and required badge */}
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12, flexWrap: "wrap", gap: 10 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div style={{
                    width: 40,
                    height: 40,
                    background: "linear-gradient(135deg, #2563eb12, #1d4ed812)",
                    borderRadius: 14,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <span style={{ fontSize: 22 }}>📋</span>
                  </div>
                  <div>
                    <label style={{ 
                      fontWeight: 700, 
                      fontSize: 18, 
                      color: "#0f172a",
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      letterSpacing: "-0.01em"
                    }}>
                      Job Description
                      <span style={{ color: "#ef4444", marginLeft: 6, fontSize: 16, fontWeight: 600 }}>*</span>
                    </label>
                    <p style={{ 
                      fontSize: 13, 
                      color: "#64748b", 
                      marginTop: 4,
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
                    }}>
                      Our AI analyzes this to build a tailored, ATS-optimized resume
                    </p>
                  </div>
                </div>
                
                {/* Character count badge */}
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  padding: "6px 14px",
                  borderRadius: 40,
                  background: jobDescription.length >= 50 ? "#ecfdf5" : jobDescription.length > 0 ? "#fffbeb" : "#f8fafc",
                  border: `1px solid ${
                    jobDescription.length >= 50 ? "#a7f3d0" :
                    jobDescription.length > 0 ? "#fde68a" :
                    "#e2e8f0"
                  }`,
                  transition: "all 0.2s"
                }}>
                  <span style={{ fontSize: 14 }}>
                    {jobDescription.length >= 50 ? "✅" : jobDescription.length > 0 ? "📝" : "⏳"}
                  </span>
                  <span style={{ 
                    fontSize: 13, 
                    fontWeight: 600,
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                    color: jobDescription.length >= 50 ? "#065f46" : jobDescription.length > 0 ? "#92400e" : "#64748b"
                  }}>
                    {jobDescription.length >= 50 
                      ? `${jobDescription.length.toLocaleString()} characters` 
                      : `${jobDescription.length}/50 characters needed`}
                  </span>
                </div>
              </div>
              
              {/* Textarea container */}
              <div style={{ position: "relative", marginTop: 8 }}>
                {/* Glow effect when ready */}
                {jobDescription.length >= 50 && (
                  <div style={{
                    position: "absolute",
                    inset: -2,
                    borderRadius: 16,
                    background: "linear-gradient(135deg, #10b981, #34d399)",
                    opacity: 0.2,
                    filter: "blur(10px)",
                    zIndex: 0
                  }} />
                )}
                
                <textarea
                  value={jobDescription}
                  onChange={(e) => setJobDescription(e.target.value)}
                  placeholder={`✨ Paste the full job description here...

            Example:
            Senior Software Engineer - FinTech

            We are seeking a Senior Software Engineer with 5+ years of experience in:
            • React, Node.js, TypeScript
            • AWS (EC2, S3, Lambda, RDS)
            • Microservices architecture
            • Leading technical projects

            Requirements:
            • Bachelor's degree in Computer Science or equivalent
            • Strong problem-solving and communication skills
            • Experience with CI/CD pipelines

            Preferred:
            • Experience in fintech or payment systems
            • AWS certification`}
                  rows={12}
                  style={{
                    width: "100%",
                    padding: "20px",
                    border: jobDescription.length >= 50 
                      ? "2px solid #a7f3d0" 
                      : jobDescription.length > 0 
                        ? "2px solid #fde68a"
                        : "2px solid #e2e8f0",
                    borderRadius: 16,
                    fontSize: 13.5,
                    lineHeight: 1.65,
                    fontFamily: "'SF Mono', 'Fira Code', 'JetBrains Mono', 'Cascadia Code', monospace",
                    fontWeight: 450,
                    resize: "vertical",
                    background: jobDescription.length >= 50 
                      ? "#fafef9"
                      : "#ffffff",
                    transition: "all 0.2s ease",
                    outline: "none",
                    boxShadow: jobDescription.length >= 50 
                      ? "0 2px 12px rgba(16,185,129,0.08)"
                      : "0 1px 3px rgba(0,0,0,0.03)",
                    position: "relative",
                    zIndex: 1,
                    color: "#1e293b"
                  }}
                  onFocus={(e) => {
                    e.target.style.borderColor = "#2563eb";
                    e.target.style.boxShadow = "0 0 0 4px rgba(37,99,235,0.08)";
                  }}
                  onBlur={(e) => {
                    if (jobDescription.length >= 50) {
                      e.target.style.borderColor = "#a7f3d0";
                      e.target.style.boxShadow = "0 2px 12px rgba(16,185,129,0.08)";
                    } else if (jobDescription.length > 0) {
                      e.target.style.borderColor = "#fde68a";
                      e.target.style.boxShadow = "none";
                    } else {
                      e.target.style.borderColor = "#e2e8f0";
                      e.target.style.boxShadow = "none";
                    }
                  }}
                />
                
                {/* Floating clear button */}
                {jobDescription.length > 0 && (
                  <button
                    onClick={() => setJobDescription("")}
                    style={{
                      position: "absolute",
                      bottom: 16,
                      right: 16,
                      background: "rgba(255,255,255,0.95)",
                      border: "1px solid #e2e8f0",
                      borderRadius: 30,
                      padding: "6px 14px",
                      fontSize: 12,
                      fontWeight: 500,
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      color: "#64748b",
                      cursor: "pointer",
                      backdropFilter: "blur(8px)",
                      transition: "all 0.2s",
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                      zIndex: 2,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
                    }}
                    onMouseEnter={(e) => {
                      e.style.background = "#fef2f2";
                      e.style.color = "#dc2626";
                      e.style.borderColor = "#fecaca";
                    }}
                    onMouseLeave={(e) => {
                      e.style.background = "rgba(255,255,255,0.95)";
                      e.style.color = "#64748b";
                      e.style.borderColor = "#e2e8f0";
                    }}
                  >
                    <span style={{ fontSize: 12 }}>🗑️</span>
                    <span>Clear all</span>
                  </button>
                )}
              </div>
              
              {/* Progress bar for minimum requirement */}
              {jobDescription.length > 0 && jobDescription.length < 50 && (
                <div style={{ marginTop: 16 }}>
                  <div style={{ 
                    height: 4, 
                    background: "#f1f5f9", 
                    borderRadius: 4,
                    overflow: "hidden"
                  }}>
                    <div style={{ 
                      width: `${(jobDescription.length / 50) * 100}%`, 
                      height: "100%", 
                      background: "linear-gradient(90deg, #f59e0b, #fbbf24)",
                      borderRadius: 4,
                      transition: "width 0.3s ease"
                    }} />
                  </div>
                  <div style={{ 
                    fontSize: 12, 
                    color: "#d97706", 
                    marginTop: 10,
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
                  }}>
                    <span style={{ fontSize: 14 }}>⚠️</span>
                    <span><strong>{50 - jobDescription.length} more characters</strong> needed for AI analysis</span>
                  </div>
                </div>
              )}
              
              {/* AI readiness indicator */}
              {jobDescription.length >= 50 && (
                <div style={{ 
                  marginTop: 18,
                  padding: "14px 18px",
                  background: "linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)",
                  borderRadius: 14,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: 14,
                  border: "1px solid #a7f3d0"
                }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <div style={{
                      width: 36,
                      height: 36,
                      background: "#10b98120",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <span style={{ fontSize: 20 }}>✨</span>
                    </div>
                    <div>
                      <div style={{ 
                        fontWeight: 700, 
                        fontSize: 14, 
                        color: "#065f46",
                        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                        marginBottom: 2
                      }}>
                        Ready for AI analysis
                      </div>
                      <div style={{ 
                        fontSize: 12, 
                        color: "#047857",
                        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
                      }}>
                        Your job description meets the requirements
                      </div>
                    </div>
                  </div>
                  
                  {/* Quick stats */}
                  <div style={{ display: "flex", gap: 20 }}>
                    <div style={{ textAlign: "center" }}>
                      <div style={{ 
                        fontSize: 20, 
                        fontWeight: 700, 
                        color: "#065f46",
                        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
                      }}>
                        {jobDescription.split(/\s+/).length}
                      </div>
                      <div style={{ fontSize: 10, color: "#047857", letterSpacing: "0.02em" }}>WORDS</div>
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <div style={{ 
                        fontSize: 20, 
                        fontWeight: 700, 
                        color: "#065f46",
                        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
                      }}>
                        {jobDescription.split('\n').filter(l => l.trim().length > 0).length}
                      </div>
                      <div style={{ fontSize: 10, color: "#047857", letterSpacing: "0.02em" }}>LINES</div>
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <div style={{ 
                        fontSize: 20, 
                        fontWeight: 700, 
                        color: "#065f46",
                        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
                      }}>
                        {(jobDescription.match(/[A-Z][a-z]+/g) || []).length}
                      </div>
                      <div style={{ fontSize: 10, color: "#047857", letterSpacing: "0.02em" }}>SKILLS</div>
                    </div>
                  </div>
                </div>
              )}
              
              {/* Pro tips section */}
              <div style={{ 
                marginTop: 18,
                padding: "16px 18px",
                background: "#f8fafc",
                borderRadius: 14,
                border: "1px solid #e2e8f0"
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
                  <span style={{ fontSize: 16 }}>💡</span>
                  <span style={{ 
                    fontWeight: 700, 
                    fontSize: 13, 
                    color: "#334155",
                    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                    letterSpacing: "-0.01em"
                  }}>
                    Pro tips for better results
                  </span>
                </div>
                <div style={{ display: "flex", flexWrap: "wrap", gap: 16 }}>
                  {[
                    { icon: "✓", text: "Include required skills & technologies", color: "#2563eb" },
                    { icon: "📊", text: "Mention years of experience", color: "#7c3aed" },
                    { icon: "🏢", text: "List company culture & values", color: "#059669" },
                    { icon: "🎯", text: "Add key responsibilities & metrics", color: "#dc2626" }
                  ].map((tip, i) => (
                    <div key={i} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <span style={{ 
                        fontSize: 13, 
                        color: tip.color,
                        fontWeight: 600
                      }}>{tip.icon}</span>
                      <span style={{ 
                        fontSize: 12, 
                        color: "#475569",
                        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
                      }}>{tip.text}</span>
                    </div>
                  ))}
                </div>
              </div>
              
              {/* Additional context */}
              <div style={{ 
                marginTop: 14,
                fontSize: 11,
                color: "#94a3b8",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: 12,
                fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
              }}>
                <span>🔒 Your data is private</span>
                <span>•</span>
                <span>⚡ Real-time analysis</span>
                <span>•</span>
                <span>🎯 Tailored results</span>
              </div>
            </div>

            {/* Template Selection */}
            <div style={{ marginBottom: 24 }}>
              <label style={{ fontWeight: 700, fontSize: 14, color: "#0f172a", marginBottom: 12, display: "block" }}>Choose a Template</label>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", gap: 16 }}>
                {TEMPLATES.map(t => (
                  <TemplateCard
                    key={t.id}
                    template={t}
                    selected={selectedTemplate === t.id}
                    onSelect={setSelectedTemplate}
                  />
                ))}
              </div>
            </div>

            {/* Generate Button */}
            <button
              onClick={handleGenerate}
              disabled={!domain || !jobDescription.trim() || jobDescription.length < 50}
              style={{
                width: "100%",
                padding: "16px",
                background: (!domain || !jobDescription.trim() || jobDescription.length < 50)
                  ? "#cbd5e1"
                  : `linear-gradient(135deg, ${activeTemplate.accent}, ${activeTemplate.headerBg})`,
                color: "#fff",
                border: "none",
                borderRadius: 12,
                fontSize: 16,
                fontWeight: 700,
                cursor: (!domain || !jobDescription.trim() || jobDescription.length < 50) ? "not-allowed" : "pointer",
                transition: "all 0.2s",
              }}
            >
              🚀 Generate My Resume
            </button>

            <p style={{ textAlign: "center", fontSize: 12, color: "#94a3b8", marginTop: 16 }}>
              Our AI will create a complete, ATS-optimized resume from scratch.
              You'll be able to download as PDF, Word, or HTML.
            </p>
          </div>
        )}

        {/* Generated Resume Preview */}
        {generated && (
          <div ref={previewRef}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20, flexWrap: "wrap", gap: 12 }}>
              <div>
                <h2 style={{ fontSize: 20, fontWeight: 800, color: "#0f172a", marginBottom: 4 }}>Your resume is ready 🎉</h2>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ fontSize: 13, color: "#64748b" }}>Styled with</span>
                  <span style={{ fontSize: 12, fontWeight: 700, padding: "2px 10px", borderRadius: 20, background: `${activeTemplate.accent}12`, color: activeTemplate.accent, border: `1px solid ${activeTemplate.accent}25` }}>{activeTemplate.name}</span>
                </div>
              </div>
              <button onClick={() => navigate("/dashboard")} style={{ padding: "8px 16px", background: "transparent", border: "1px solid #e2e8f0", borderRadius: 9, fontSize: 13, color: "#475569", cursor: "pointer", fontWeight: 500 }}>
                Back to Dashboard
              </button>
            </div>

            {/* Warning */}
            <div style={{ background: "#FCEBEB", border: "2px solid #f0a0a0", borderRadius: 12, padding: "13px 16px", marginBottom: 16 }}>
              <div style={{ display: "flex", gap: 10 }}>
                <span style={{ fontSize: 18, flexShrink: 0 }}>⚠️</span>
                <p style={{ fontSize: 13, color: "#A32D2D", margin: 0, lineHeight: 1.7 }}>
                  <strong>Before you send this out:</strong> replace the fictional companies, dates, and contact details with your real ones.
                </p>
              </div>
            </div>

            {/* Downloads */}
            <div style={{ background: "#fff", borderRadius: 14, border: "1px solid #e2e8f0", padding: "20px", marginBottom: 20 }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: "#0f172a", marginBottom: 4 }}>⬇ Download your resume</div>
              <p style={{ fontSize: 12, color: "#64748b", marginBottom: 14 }}>PDF is recommended for job applications.</p>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10 }}>
                {[
                  { f: "pdf", icon: pdfLoading ? "⏳" : "📄", label: pdfLoading ? "Generating..." : "PDF", sub: "✅ Recommended", primary: true },
                  { f: "html", icon: "🌐", label: "HTML", sub: "Print in browser", primary: false },
                  { f: "word", icon: "📝", label: "Word", sub: "Editable .docx", primary: false },
                ].map(b => (
                  <button key={b.f} onClick={() => handleDownload(b.f)}
                    style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4, padding: "13px 10px", borderRadius: 10, border: b.primary ? "none" : "1.5px solid #e2e8f0", background: b.primary ? `linear-gradient(135deg,${activeTemplate.accent},${activeTemplate.headerBg})` : "#fff", color: b.primary ? "#fff" : "#475569", cursor: "pointer", position: "relative", fontWeight: b.primary ? 700 : 600, fontSize: 13 }}>
                    {b.primary && <span style={{ position: "absolute", top: -8, right: -4, fontSize: 9, fontWeight: 800, background: "#059669", color: "#fff", padding: "2px 6px", borderRadius: 20 }}>Best</span>}
                    <span style={{ fontSize: 22 }}>{b.icon}</span>
                    <span>{b.label}</span>
                    <span style={{ fontSize: 10, opacity: 0.75 }}>{b.sub}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* Preview */}
            <div style={{ background: "#e8e8e8", padding: "24px 16px", borderRadius: 12, marginBottom: 20 }}>
              <div style={{ maxWidth: 860, margin: "0 auto", position: "relative" }}>
                <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%) rotate(-35deg)", fontSize: 80, fontWeight: 900, color: "rgba(0,0,0,0.04)", pointerEvents: "none", whiteSpace: "nowrap", zIndex: 10, userSelect: "none" }}>SAMPLE</div>
                <div style={{ background: "#fff", borderRadius: 4, boxShadow: "0 8px 32px rgba(0,0,0,0.15)", overflow: "hidden", position: "relative" }}>
                  <iframe title="Resume Preview"
                    srcDoc={buildResumeHTML(generated, selectedTemplate, { showHint: false })}
                    style={{ width: "100%", border: "none", display: "block", minHeight: "800px" }}
                  />
                </div>
              </div>
            </div>

            {downloaded && <p style={{ textAlign: "center", fontSize: 12, color: "#94a3b8", marginTop: 10 }}>✅ Downloaded. Remember to personalise with your real details.</p>}
          </div>
        )}
      </div>
    </div>
  );
}